/**
 * Which store a device belongs to: 'ios' | 'android' | null (a computer, or
 * something we can't place). Reads the user agent; iPadOS 13+ reports itself
 * as a Mac, so the touch points settle that case.
 *
 * @param {Navigator|null} [nav]  injectable for tests
 */
export default function detectMobileOS(nav = typeof navigator !== 'undefined' ? navigator : null) {
    if (!nav) return null;

    const ua = nav.userAgent || '';
    if (/android/i.test(ua)) return 'android';
    if (/iphone|ipad|ipod/i.test(ua)) return 'ios';
    if (nav.platform === 'MacIntel' && (nav.maxTouchPoints || 0) > 1) return 'ios';

    return null;
}
